// extracted by mini-css-extract-plugin
export default {"genInput":"Input_genInput__muLcY","genInputError":"Input_genInputError__E6LyM"};